import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToDoSelectCentralService } from '../../utils/request';
import {
  IDeactivateRecruiter,
  IInviteRecruiter,
} from '../../types/recruiter.types';
import { PRODUCT } from '../../constants/RecruiterDashboard/roles.constant';

export const inviteRecruiter = (data: IInviteRecruiter, username: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.POST,
    url: `/rpc/invite.create?__env=PLT&__user=${username}&product=${PRODUCT}`,
    data,
  });

export const toggleRecruiterStatus = (
  data: IDeactivateRecruiter,
  username: string
) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.POST,
    url: `/rpc/toggle_recruiter_status?__env=PLT&__user=${username}&product=${PRODUCT}`,
    data,
  });
